import Specialist from "./components/Specialist.vue";
import SpecialistDashboard from "./components/SpecialistDashboard.vue";
import SpecialistCompare from "./components/SpecialistCompare.vue";
import landingPage from "./components/landingPage";
import Register from "./components/Register";
import loginPage from "./components/loginPage";
import DashboardSetting from "./components/DashboardSetting.vue";
import Dummy from "./components/Dummy.vue";
import HubSystem from "./components/HubSystem";
import ApplicationSystem from "./components/ApplicationSystem";
import ReportsStatistics from "./components/ReportsStatistics";
import ConfigureReport from "./components/ConfigureReport";
import AboutUs from "./components/AboutUs.vue";
import UserManagePage from "./components/UserManagePage.vue";
import RolesPage from "./components/RolesPage.vue";
import SearchAppAdminApps from "./components/SearchAppAdminApps.vue";
import ViewAppAdminApps from "./components/ViewAppAdminApps.vue";
import ViewAllApplications from "./components/ViewAllApplications.vue";
import CloneApplication from "./components/CloneApplication";
import NewApplicationCard from "./components/NewApplicationCard.vue";
import ApplicationConfig from "./components/ApplicationConfig.vue";
import TestAppMenu from "./components/TestAppMenu.vue";
import AppTester from "./components/AppTester";
import Dashboard from "./components/Dashboard.vue";
import Activities from "./components/Activities.vue";
import ApplicationPage from "./components/ApplicationPage.vue";
import AppUsuage from "./components/AppUsuage.vue";
import AppUsuageReport from "./components/AppUsuageReport.vue";
import ForgotPasword from "./components/ForgotPasword.vue";
import ActivityChildView from "./components/ActivityChildView.vue";

export default [
  { 
    path: "/", name: "landingPage", component: landingPage, 
    meta: { requiresAuth: false, showFooter: true, showHeader: true } 
  },
  { 
    name: "Specialist", path: "/specialist", component: Specialist, 
    meta: { requiresAuth: true, showFooter: true, showHeader: true } 
  },
  { 
    name: "SpecialistDashboard", path: "/specialistDashboard", component: SpecialistDashboard, props: true, 
    meta: { requiresAuth: true, showFooter: true, showHeader: true }
  },
  { 
    name: "SpecialistCompare", path: "/specialistCompare", component: SpecialistCompare, props: true, 
    meta: { requiresAuth: true, showFooter: true, showHeader: true }
  },
  { 
    name: "Register", path: "/register", component: Register, 
    meta: { requiresAuth: false, showFooter: true, showHeader: true }
  },
  { 
    name: "ForgotPasword", path: "/forgot-password", component: ForgotPasword, 
    meta: { requiresAuth: false, showFooter: true, showHeader: true }
  },
  { 
    name: "Login", path: "/login", component: loginPage, 
    meta: { requiresAuth: false, showFooter: true, showHeader: true }
  },
  { 
    path: "/dashboardSetting", component: DashboardSetting, 
    meta: { requiresAuth: true, showFooter: true, showHeader: true }
  },
  { 
    path: "/pageNotAvailable", component: Dummy, 
    meta: { requiresAuth: false, showFooter: true, showHeader: true }
  },
  { 
    path: "/aboutUs", component: AboutUs, 
    meta: { requiresAuth: false, showFooter: true, showHeader: true }
  },
  { 
    path: "/userManagePage", component: UserManagePage, 
    meta: { requiresAuth: true, showFooter: true, showHeader: true }
  },
  { 
    path: "/rolesPage", name:"rolesPage", component: RolesPage, 
    meta: { requiresAuth: true, showFooter: true, showHeader: true }
  },
  { 
    path: "/rolesPage/viewAllApplications", name:"viewAllApplications", component: ViewAllApplications, 
    meta: { requiresAuth: true, showFooter: true, showHeader: true }
  },
  { 
    path: "/rolesPage/searchAppAdminApps", name:"searchAppAdminApps", component: SearchAppAdminApps, 
    meta: { requiresAuth: true, showFooter: true, showHeader: true }
  },
  { 
    path: "/rolesPage/searchAppAdminApps/viewAppAdminApps", name:"viewAppAdminApps", component: ViewAppAdminApps, 
    meta: { requiresAuth: true, showFooter: true, showHeader: true }
  },
  { 
    path: "/rolesPage/searchAppAdminApps/viewAppAdminApps/cloneAppName", name:"cloneApp", component: CloneApplication, 
    meta: { requiresAuth: true, showFooter: true, showHeader: true }
  },
  { 
    path: "/rolesPage/searchAppAdminApps/viewAppAdminApps/newAppCard", name:"NewAppCard", component: NewApplicationCard, 
    meta: { requiresAuth: true, showFooter: true, showHeader: true }
  },
  { 
    path: "/rolesPage/searchAppAdminApps/viewAppAdminApps/newAppCard/:applicationID", name:"ApplicationConfig", component: ApplicationConfig, 
    meta: { requiresAuth: true, showFooter: false, showHeader: true }
  },
  { 
    path: "/individualReport/:reportID", name: "configureReport", component: ConfigureReport, 
    meta: { requiresAuth: true, showFooter: true, showHeader: true }
  },
  { 
    path: "/testAppMenu/:applicationID", name: "testAppMenu", component: TestAppMenu, 
    meta: { requiresAuth: true, showFooter: true, showHeader: true }
  },
  { 
    path: "/appTester/:applicationID", name: "appTester", component: AppTester, 
    meta: { requiresAuth: true, showFooter: false, showHeader: true }
  },
  { 
    path: "/dashboard", name: "dashboarBoard", component: Dashboard, 
    meta: { requiresAuth: true, showFooter: false, showHeader: true }
  },
  { 
    path: "/reportsStatistics", name: "reportsStatistics", component: ReportsStatistics, 
    meta: { requiresAuth: true, showFooter: true, showHeader: true }
  },
  { 
    path: "/hubSystem", component: HubSystem, 
    meta: { requiresAuth: true, showFooter: true, showHeader: true }
  },
  { 
    path: "/hubSystem/:hubid", component: ApplicationSystem, 
    meta: { requiresAuth: true, showFooter: true, showHeader: true }
  },
  { 
    path: "/activities", component: Activities, 
    meta: { requiresAuth: true, showFooter: false, showHeader: true }
  },
  { 
    path: "/application/:applicationID", component: ApplicationPage, 
    meta: { requiresAuth: true, showFooter: true, showHeader: true }
  },
  { 
    path: "/activity/:activityID", component: AppUsuage, 
    meta: { requiresAuth: true, showFooter: false, showHeader: true }
  },
  { 
    path: "/activity/childView/:activityID", component: ActivityChildView, 
    meta: { requiresAuth: false, showFooter: false, showHeader: false }
  },
  { 
    path: "/activity/report/:activityID", component: AppUsuageReport, 
    meta: { requiresAuth: true, showFooter: true, showHeader: true }
  }
];
